import { render, staticRenderFns } from "./AccessibilityResult.vue?vue&type=template&id=b5c27a66&scoped=true"
import script from "./AccessibilityResult.vue?vue&type=script&lang=js"
export * from "./AccessibilityResult.vue?vue&type=script&lang=js"
import "./AccessibilityResult.vue?vue&type=style&index=0&id=b5c27a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c27a66",
  null
  
)

export default component.exports